import { render, staticRenderFns } from "./AnswerResult.vue?vue&type=template&id=53b5c9a8"
import script from "./AnswerResult.vue?vue&type=script&lang=js"
export * from "./AnswerResult.vue?vue&type=script&lang=js"
import style0 from "./AnswerResult.vue?vue&type=style&index=0&id=53b5c9a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports